// src/components/Dashboard.js
import React, { useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import '../Button.css';
import '../topmenu.css';
import './Dashboard.css';
import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Section3';
import Section4 from './Section4';

const Dashboard = ({  }) => {
  const { t } = useTranslation();
  // Auto refresh every 5 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      window.location.reload();
    }, 300000); // 5 minutes in milliseconds
    return () => clearInterval(interval);
  }, []);

  return (

	<div className="content">

		<div className="top-menu"></div>

		<div className="content__main-title">{t('Dashboard.MaintenanceDashboard')}</div>

		<div className="db-container">

			<Section1 />
			<Section2 />
			<Section3 />
			<Section4 />
           
        </div>
    </div>
  );
};

export default Dashboard;
